import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import {
  getFreeTrialStatusError,
  getFreeTrialStatusSuccess,
  setFreeTrialStatusError,
  setFreeTrialStatusSuccess,
} from './actions'
import { GET_FREE_TRIAL_STATUS, SET_FREE_TRIAL_STATUS } from './constants'

const upgradeModalEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(GET_FREE_TRIAL_STATUS.INITIATE).mergeMap(() =>
    api.companies
      .getFreeTrialStatus(store.getState().partnerOptions.selectedCompany?.value)
      .map(({ isValidForTrial, message }) => getFreeTrialStatusSuccess(isValidForTrial, message))
      .catch((error) => Observable.of(epicsErrorHandler(getFreeTrialStatusError, error)))
  )

const setFreeTrialEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SET_FREE_TRIAL_STATUS.INITIATE).mergeMap((action) =>
    api.companies
      .setFreeTrialStatus(store.getState().partnerOptions.selectedCompany?.value, {
        sendEmailOnly: action.payload.value,
      })
      .map(({ status, message }) => setFreeTrialStatusSuccess(status, message))
      .catch((error) => Observable.of(epicsErrorHandler(setFreeTrialStatusError, error)))
  )

export default combineEpics(upgradeModalEpic, setFreeTrialEpic)
